import { render, staticRenderFns } from "./opportunity-info.vue?vue&type=template&id=093dbf64"
import script from "./opportunity-info.vue?vue&type=script&lang=js"
export * from "./opportunity-info.vue?vue&type=script&lang=js"
import style0 from "./opportunity-info.vue?vue&type=style&index=0&id=093dbf64&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports